const Jsw = require('./common').default;

Jsw.BrowserFeatures = require('./browser-features').BrowserFeatures;
Jsw.Component = require('./component').Component;
Jsw.Locale = require('./locale').Locale;
Jsw.Hint = require('./hint').Hint;
Jsw.Button = require('./button').Button;
Jsw.SmallButton = require('./small-button').SmallButton;
Jsw.BigButton = require('./big-button').BigButton;
Jsw.SplitButton = require('./split-button').SplitButton;
Jsw.CommandButton = require('./command-button').CommandButton;
Jsw.CustomButton = require('./custom-button').CustomButton;

Jsw.FormRedirect = require('./form-redirect').FormRedirect;
Jsw.submit = require('./form-redirect').submit;
Jsw.redirect = require('./form-redirect').redirect;
Jsw.redirectPost = require('./form-redirect').redirectPost;

Jsw.form = {
    DisplayField: require('./form').DisplayField,
    Values: require('./form').Values,
    Form: require('./form/form').Form,
    GetPassword: require('./form/get-password').GetPassword,
    Login: require('./form/login').Login,
    RestorePassword: require('./form/restore-password').RestorePassword,
};

Jsw.FormAjax = require('./form-ajax').FormAjax;
Jsw.Container = require('./container').Container;
Jsw.ListContainer = require('./list-container').ListContainer;

Jsw.layout = {
    TwoColumns: require('./layout').TwoColumns,
};

Jsw.Cookie = require('./cookie').Cookie;
Jsw.Panel = require('./panel').Panel;

Jsw.messageBox = require('./message-box').messageBox;
Jsw.MessageBox = require('./message-box').MessageBox;
Jsw.AjaxMessageBox = require('./message-box').AjaxMessageBox;
Jsw.MultiCheckboxMessageWindow = require('./message-box').MultiCheckboxMessageWindow;
Jsw.WebspaceFoldersMessageBox = require('./message-box').WebspaceFoldersMessageBox;

Jsw.ListContextMenu = require('./list-context-menu').ListContextMenu;
Jsw.DropdownManager = require('./dropdown-manager').DropdownManager;
Jsw.SmallTools = require('./small-tools').SmallTools;
Jsw.CollapsibleBlock = require('./collapsible-block').CollapsibleBlock;
Jsw.Collapsible = require('./collapsible').Collapsible;
Jsw.Dropdown = require('./dropdown').Dropdown;
Jsw.Pathbar = require('./pathbar').Pathbar;

Jsw.Bar = require('./bar').Bar;
Jsw.bar = require('./bar').bar;

Jsw.DynamicSubForm = require('./dynamic-sub-form').DynamicSubForm;
Jsw.AddRemoveDynamicSubForm = require('./dynamic-sub-form').AddRemoveDynamicSubForm;

Jsw.Box = require('./box').Box;
Jsw.Gauge = require('./gauge').Gauge;
Jsw.Tooltip = require('./tooltip').Tooltip;
Jsw.ModalDialogBox = require('./modal-dialog-box').ModalDialogBox;
Jsw.PopupForm = require('./popup-form').PopupForm;
Jsw.AjaxPopupForm = require('./ajax-popup-form').AjaxPopupForm;
Jsw.Popup = require('./popup').Popup;
Jsw.DoubleListSelector = require('./double-list-selector').DoubleListSelector;
Jsw.EnhancedDoubleListSelector = require('./enhanced-double-list-selector').EnhancedDoubleListSelector;
Jsw.ImageSelector = require('./image-selector').ImageSelector;

Jsw.ToolList = require('./tool-list').ToolList;
Jsw.toollist = require('./tool-list').toollist;

Jsw.DynamicPopupHint = require('./dynamic-popup-hint').DynamicPopupHint;
Jsw.PasswordMeter = require('./password-meter').PasswordMeter;
Jsw.PasswordGenerator = require('./password-generator').PasswordGenerator;
Jsw.UpgradeFailureNotification = require('./upgrade-failure-notification').UpgradeFailureNotification;
Jsw.CustomDescription = require('./custom-description').CustomDescription;
Jsw.ConfirmationPopupManager = require('./confirmation-popup-manager').ConfirmationPopupManager;
Jsw.LookUp = require('./lookup').LookUp;
Jsw.StatusMessage = require('./status-message').StatusMessage;
Jsw.Observer = require('./observer').Observer;
Jsw.ResponsiveDropdown = require('./responsive-dropdown').ResponsiveDropdown;
Jsw.SearchResponsiveDropdown = require('./search-responsive-dropdown').SearchResponsiveDropdown;

Jsw.Task = {
    ProgressBar: require('./task-progress-bar').ProgressBar,
};

Jsw.ScheduledTasks = require('./scheduled-tasks').ScheduledTasks;
Jsw.ActiveList = require('./active-list').ActiveList;

Jsw.FileManager = {
    Tree: require('./file-manager/tree').Tree,
    UploadAdapterIframe: require('./file-manager/upload-adapter-iframe').UploadAdapterIframe,
};

Jsw.DirectoryBrowser = require('./directory-browser').DirectoryBrowser;
Jsw.DropArea = require('./drop-area').DropArea;
Jsw.GroupsList = require('./groups-list').GroupsList;
Jsw.ReporterPopup = require('./issue-reporter').ReporterPopup;
Jsw.ObjectSwitcher = require('./object-switcher').ObjectSwitcher;
Jsw.PopupSlider = require('./popup-slider').PopupSlider;
Jsw.ProgressDialog = require('./progress-dialog').ProgressDialog;
Jsw.ScrollableList = require('./scrollable-list').ScrollableList;
Jsw.UAT = require('./uat').UAT;

Jsw.List = require('./list').List;
Jsw.List.Filters = require('./list/filters').Filters;

Jsw.list = require('./list').list;
Jsw.list.Domains = require('./list/domains').Domains;

require('./promise');

module.exports = Jsw;



// WEBPACK FOOTER //
// ./jsw/index.js